// Color and font constants extracted from the three @react-pdf/renderer CV
// templates (common / cssf / europass). Hex values are stored WITHOUT '#'
// because that is what the `docx` library expects.
//
// These mirror the StyleSheet values in src/components/edition-resume-pdf/*.

// Theme accent for the `common` variant depends on the isAlcyone flag.
export const COMMON_ALCYONE_ACCENT = '09B4BF';
export const COMMON_STANDARD_ACCENT = '0B86C8';

// Greys / neutrals shared across variants.
export const TEXT_BLACK = '000000';
export const HEADER_GREY = '808080'; // common header "X years experience"
export const INACTIVE_DASH = 'CCCCCC'; // common business-skills rating

// CSSF palette.
export const CSSF_ACCENT = '009999';
export const CSSF_TEXT = '3F3A38';
export const CSSF_FOOTER = '006D88';
export const CSSF_RULE = '979797';

// Europass palette.
export const EUROPASS_HEADER_BG = 'F5F5F5';
export const EUROPASS_USER = '565656';
export const EUROPASS_TEXT = '3F3F3F';
export const EUROPASS_RULE = '979797';
export const EUROPASS_BLUE = '0B86C8'; // declared in PDF stylesheet (language section)

// Default fonts per variant (system fonts; not embedded).
export const FONT_ARIAL = 'Arial';
export const FONT_VERDANA = 'Verdana';

// Resolve the common-variant accent from the isAlcyone flag.
export function commonAccent( isAlcyone ) {
    return isAlcyone ? COMMON_ALCYONE_ACCENT : COMMON_STANDARD_ACCENT;
}
